import Card from '@/components/card/card-component';
import { Row } from '@/components/grid/grid-component';
import { Subtitle2Text } from '@/utils/global-fonts';
import styled from 'styled-components';

const CardStyle = styled(Card)`
  margin-top: 24px;
  padding: 9px !important;
`;

const RowStyle = styled(Row)`
  margin-left: 0 !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
  margin-right: 0 !important;
  margin-bottom: 0 !important;
  justify-content: space-between !important;
`;

const ButtonDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-content: center;
  flex-direction: row;
`;

const TabContainer = styled.div`
  width: 150px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  flex-direction: row;
`;

const Tab = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 20px 8px 20px;
  border: ${({ active }) => (active ? 'none' : '1px solid #EAEDF3')};
  outline: none;
  width: 72px;
  height: 32px;
  text-decoration: none;
  background-color: ${({ active, theme }) =>
    active ? theme.COLOR_PRIMARY : theme.COLOR_WHITE};
  cursor: pointer;
`;

const Label = styled(Subtitle2Text)`
  color: ${({ active, theme }) =>
    active ? theme.COLOR_WHITE : theme.COLOR_BLACK};
`;

const Line = styled.div`
  border-bottom: 1px solid #ccc;
  width: inherit;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 14px;
  height: 48px;
  border: 1px solid ${({ theme }) => theme.COLOR_GREY5};
  border-radius: 4px;
`;

const LabelText = styled.label`
  color: ${(props) => props.theme.COLOR_GREY_TEXT};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.4px;
  margin-top: 16px;
  text-align: left;
`;

const StyledQuotingModule = {
  CardStyle,
  RowStyle,
  ButtonDiv,
  TabContainer,
  Container,
  LabelText,
  Tab,
  Label,
  Line,
};

export default StyledQuotingModule;
